import { Signal } from 'typed-signals';
import { RaceEventSharePopupLayout } from '../../../../layouts/raceEvent/RaceEventSharePopupLayout';
import type { Popup } from '../../../popups/Popup';
import { safeAreaDimensions } from '../../../app/RendererPlugin';

export class RaceEventSharePopup implements Popup {
  public static readonly requiredLayouts = [RaceEventSharePopupLayout];

  public onShare = new Signal<(imageToShare: Promise<string>) => void>();

  public onClose = new Signal();

  private readonly layout = new RaceEventSharePopupLayout();

  public readonly root = this.layout.root;

  constructor(progress: number) {
    const {
      layout: { progressText, shareButton, closeButton, root },
    } = this;
    progressText.text = `#${progress}`;
    root.alpha = 0;

    closeButton.on('pointertap', () => {
      this.onClose.emit();
    });

    shareButton.root.on('pointertap', () => {
      this.onShare.emit(this.root.pixi.renderer.extract.base64(this.layout.shareContainer));
    });
  }

  public resize(): void {
    const {
      layout: { gradient, contentWrapper, root },
      root: {
        pixi: { renderer },
      },
    } = this;

    root.y = renderer.height * -0.5;

    gradient.props({
      width: renderer.width * 1.1,
      height: renderer.height * 1.1,
    });

    contentWrapper.props({
      y: Math.floor((renderer.height - safeAreaDimensions.height) * 0.5),
    });
  }
}
